<section class="navbar-section">
  <ul
    ngbNav
    [activeId]="route.fragment | async"
    [(activeId)]="active"
    class="nav d-flex justify-content-between px-3"
    style="border-radius: 20px; height: 90px; background-color: #fff"
  >
    <div class="d-flex nav-box">
      <app-logo class="px-4" />
      @for (link of links; track link) {
        <li ngbNavItem *hasRole="link.roles">
          <a
            ngbNavLink
            [routerLink]="link.routerLink"
            routerLinkActive="active"
            >{{ link.label | translate }}</a
          >
        </li>
      }
    </div>
    @if (!environment.production) {
      <mat-button-toggle-group
        (change)="updateLocale($event)"
        name="favoriteColor"
        aria-label="Favorite Color"
      >
        <mat-button-toggle value="en" checked>EN</mat-button-toggle>
        <mat-button-toggle value="fr">FR</mat-button-toggle>
      </mat-button-toggle-group>
    }
    <app-profile-cabinet (onLogOut)="handleLogOut()" />
  </ul>
</section>
